<template>
  <div class="width-100">
    <h2 class="section-title">{{ $t('samplegrouping.title') }}</h2>

    <Filters
      :filters="groupingsFilters"
      filter-key="groupings"
      :initial-data="filtersStatus.groupings"
      :loading="filtersLoading"
    />

    <TableWrapper
      :table-columns="groupingsColumns"
      table-key="groupings"
      row-key="rowId"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import Filters from '@/components/Filters.vue';
  import TableWrapper from '@/components/TableWrapper.vue';
  import groupingsApi from '@/api/groupings';
  import { groupingsFilters, groupingsColumns } from '@/config/';
  import abortControllerMixin from '@/mixins/abortControllerMixin';
  import filterLoadingMixin from '@/mixins/filterLoadingMixin';
  import axios from 'axios';

  export default {
    name: 'SampleGroupingInfos',
    components: {
      Filters,
      TableWrapper,
    },
    mixins: [abortControllerMixin, filterLoadingMixin],
    props: {
      visible: { type: Boolean, default: false },
      groupingInfoId: { type: Number, default: null },
    },
    data() {
      return {
        groupingsColumns,
        groupingsFilters,
        groupingId: undefined,
        sampleAnalyses: [],
        loading: false,
      };
    },
    computed: {
      ...mapGetters(['tableFilters', 'filtersStatus']),
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
      ]),
      closeDialog() {
        this.$emit('dialogClose');
      },
      async tableRows() {
        const signal = this.createAbortController();
        this.filtersLoading = true;
        let aborted = false;
        this.loading = true;
        try {
          const response = (
            await groupingsApi.index(
              this.tableFilters('groupings'),
              this.filtersStatus.groupings,
              { signal }
            )
          ).data.map((item) => {
            const children = item.analysis.map((analysis) => ({
              code: analysis.code,
              description: analysis.description,
              rowId: `${item.id}.${analysis.id}`,
            }));
            return {
              ...item,
              rowId: item.id,
              children,
            };
          });
          const countResponse = await groupingsApi.count(
            this.filtersStatus.groupings,
            { signal }
          );
          this.updateTableRows({ tableKey: 'groupings', rows: response });
          this.updateTableCount({
            tableKey: 'groupings',
            count: countResponse.data.count,
          });
          this.loading = false;
        } catch (error) {
          if (axios.isCancel(error)) {
            aborted = true;
            return;
          }
          this.loading = false;
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        } finally {
          if (!aborted) {
            this.filtersLoading = false;
          }
        }
      },
    },
    async created() {
      this.parseQueryStringStatus(this.$route.query);
      this.updateTableRows({ tableKey: 'groupings', rows: [] });
      this.updateTableCount({ tableKey: 'groupings', count: 0 });
      this.tableRows();
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows(to.query);
      next();
    },
  };
</script>

<style lang="scss"></style>
